<template>
  <div class="Info">
    <div class="title">{{title}}</div>
    <div class="panel">
      <div class="notice">
        <div class="item" v-for="n in notice">{{n}}</div>
      </div>
      <div class="button">
        <div class="area">
          <div class="p">{{user.area}}</div>
          <div class="c">{{user.city}}</div>
        </div>
        <div class="group">
          <!-- <my_image class="img" :src="group.img" :width="imgWidth"></my_image> -->
          <div class="text">{{group.text}}</div>
        </div>
        <my_button v-if="user.enrolled&&procedure" :value="'开始比赛'" :inputStyle="buttonStyle" @click.native="start"></my_button>
        <my_button v-if="user.enrolled&&!procedure" :value="'比赛即将开始'" :inputStyle="style2" ></my_button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
 import MyButton from '@/components/Button.vue'
 import MyImage from '@/components/Image.vue';

 import groupS1 from '../../assets/image/enroll/group-s1.png'
 import groupS2 from '../../assets/image/enroll/group-s2.png'
 import groupM from '../../assets/image/enroll/group-m.png'

 export default {
   name: 'Info',
   data () {
     return {
     }
   },
   methods: {
     start(){
       if(this.user){
         if(this.user.enrolled)
           {
           this.$router.push({name: 'Preliminary'})
           }
         else
           {
             this.$router.push({name: 'enroll'})
           }
       }
       else
         {
           this.$router.push({name:'account', params:{type:'login'}})
         }

     }
   },
   computed: {
     title() {
       return '报名信息'
     },
     procedure() {
       return this.$store.state.procedure
     },
 style2() {
        return {
         'background-color': 'grey',
         'font-size': '0.9375vw',
         'color': '#241171',
         'height': '2.6vw',
         'border-radius': '3px'
       }
     },

     imgWidth() {
       return '4.75vw'
     },
     imgs() {
       return [groupS1, groupS2, groupM]
     },
     notice () {
       return this.$store.state.enroll.notice;
     },
     group() {
       let groups = this.$store.state.enroll.groups
       return {
         img: this.imgs[this.user.group-1],
         text:  groups[this.user.group-1].text + groups[this.user.group-1].extra
       }
     },
     buttonStyle () {
       return {
         'background-color': '#F8E900',
         'font-size': '0.9375vw',
         'color': '#241171',
         'height': '2.6vw',
         'border-radius': '3px'
       }
     },
     user() {
       return this.$store.state.auth.user
     }
   },
   components:{
     my_button: MyButton,
     my_image: MyImage
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Info{
   width: 62.5vw;
   height: 20.73vw;
   box-sizing: border-box;
   padding-top: 2.4vw;
   padding-bottom: 2.13vw;
   padding-left: 4vw;
   padding-right: 4vw;
   /* background-image: url(~@/assets/image/enroll/bg-info.png); */
   background-image: url('/oss/images/enroll/bg-info.png');
   background-size: 62.5vw;
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: space-between;
 }
 .title{
   color: white;
   font-size: 1.875vw;
   line-height: 1.85vw;
   display: flex;
   align-items:center;
   justify-content: center;
 }
 .panel{
   width: 100%;
   display: flex;
   align-items: center;
   justify-content:space-between;
 }

 .notice{
   width: 41.93vw;
   height: 11.77vw;
   color: white;
   line-height: 1.5625vw;
 }
 .group{
   text-align:center;
   color: white;
 }
 .button{
   width: 7.6vw;
   display: flex;
   height: 9vw;
   flex-direction: column;
   justify-content: space-between;
   position: relative;
 }
 .p, .c{
   min-width: 3.16vw;
   height: 1.6875vw;
   display: flex;
   box-sizing: border-box;
   align-items:center;
   justify-content:center;
   color: white;
   background-color: #BEBCFF;
 }

</style>
